var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCryptoBasis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 57,
    viewBox: "0 0 52 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M13.7774 11.2458C14.1895 11.2458 14.5681 11.1064 14.8722 10.8744L19.7704 13.9887C19.8744 14.0547 19.9904 14.0863 20.1051 14.0863C20.3118 14.0863 20.514 13.9839 20.6332 13.7965C20.8184 13.5053 20.7324 13.119 20.4411 12.9338L15.5446 9.82067C15.5714 9.69704 15.5863 9.56892 15.5863 9.43717C15.5863 8.43817 14.7765 7.62842 13.7775 7.62842C12.7785 7.62842 11.9688 8.43817 11.9688 9.43717C11.9686 10.4359 12.7785 11.2458 13.7774 11.2458Z",
    fill: "#F79009"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M50.8409 23.363L42.0286 5.33609C41.7254 4.71584 40.9769 4.45884 40.3566 4.76209L16.1969 16.5725C16.148 16.4723 16.0735 16.3831 15.9726 16.3188L7.57588 10.9795C7.6025 10.856 7.61738 10.7281 7.61738 10.5966C7.61738 9.59771 6.8075 8.78784 5.80863 8.78784C4.80975 8.78784 3.99975 9.59759 3.99975 10.5966C3.99975 11.5956 4.8095 12.4053 5.8085 12.4053C6.22088 12.4053 6.59975 12.2657 6.904 12.0335L14.9785 17.168L12.0781 18.5858C11.4579 18.889 11.2009 19.6376 11.5041 20.2578L13.687 24.7232H11.0312C9.6505 24.7232 8.53125 25.8425 8.53125 27.2232V33.2778C4.38912 33.2778 1.03125 36.6357 1.03125 40.7778C1.03125 44.92 4.38912 48.2778 8.53125 48.2778V53.8652C8.53125 55.246 9.6505 56.3652 11.0312 56.3652H44.1025C45.4832 56.3652 46.6025 55.246 46.6025 53.8652V45.9082C47.2158 45.8283 47.6898 45.3051 47.6898 44.67V36.4183C47.6898 35.7833 47.2158 35.2601 46.6025 35.1801V27.2231C46.6025 27.0931 46.5895 26.9665 46.5704 26.8418L50.2667 25.035C50.8871 24.7317 51.1441 23.9831 50.8409 23.363Z",
    fill: "#F79009"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.265 22.0349L21.9865 35.8585C21.3662 36.1618 20.6177 35.9046 20.3145 35.2845L11.5022 17.2578C11.1991 16.6375 11.4561 15.889 12.0762 15.5858L40.3549 1.76201C40.9751 1.45888 41.7236 1.71588 42.0269 2.33601L50.8391 20.3628C51.1422 20.983 50.8852 21.7316 50.265 22.0349Z",
    fill: "#FFD194"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8057 3.92664L12.2812 18.8491L14.7498 23.8986L45.2743 8.9761L42.8057 3.92664Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.265 22.0349L21.9865 35.8585C21.3662 36.1618 20.6177 35.9046 20.3145 35.2845L11.5022 17.2578C11.1991 16.6375 11.4561 15.889 12.0762 15.5858L40.3549 1.76201C40.9751 1.45888 41.7236 1.71588 42.0269 2.33601L50.8391 20.3628C51.1422 20.983 50.8852 21.7316 50.265 22.0349Z",
    stroke: "#F79009",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1055 13.4577L43.451 12.311",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7852 18.0505L44.6227 14.708",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2823 26.7266C22.8907 26.7266 21.5939 25.9587 20.8982 24.7228L17.6156 18.8919C16.9198 17.6559 16.9198 16.1204 17.6156 14.8846L20.8983 9.05355C21.5939 7.81768 22.8907 7.0498 24.2823 7.0498H30.8476C32.2393 7.0498 33.5359 7.81768 34.2318 9.05355L37.5143 14.8844C38.2101 16.1204 38.2101 17.6559 37.5144 18.8918L34.2317 24.7228C33.5361 25.9587 32.2393 26.7266 30.8476 26.7266H24.2823Z",
    fill: "#FFD194"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2823 26.7266C22.8907 26.7266 21.5939 25.9587 20.8982 24.7228L17.6156 18.8919C16.9198 17.6559 16.9198 16.1204 17.6156 14.8846L20.8983 9.05355C21.5939 7.81768 22.8907 7.0498 24.2823 7.0498H30.8476C32.2393 7.0498 33.5359 7.81768 34.2318 9.05355L37.5143 14.8844C38.2101 16.1204 38.2101 17.6559 37.5144 18.8918L34.2317 24.7228C33.5361 25.9587 32.2393 26.7266 30.8476 26.7266H24.2823Z",
    stroke: "#F79009",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0823 9.42188H24.0486C23.6244 9.42188 23.2333 9.6505 23.0253 10.0201L19.4831 16.3123C19.2817 16.6699 19.2817 17.1067 19.4831 17.4644L23.0253 23.7565C23.2333 24.126 23.6244 24.3547 24.0486 24.3547H31.0823C31.5064 24.3547 31.8976 24.1261 32.1056 23.7565L35.6478 17.4644C35.8492 17.1067 35.8492 16.6699 35.6478 16.3123L32.1056 10.0201C31.8974 9.6505 31.5063 9.42188 31.0823 9.42188Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4521 12.0576H26.9766V21.7187",
    stroke: "#FFD194",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8445 21.7187L22.125 16.8881L24.8445 18.0049V12.0576",
    stroke: "#FFD194",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9766 16.7207H28.2948",
    stroke: "#FFD194",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4492 14.3643V21.7184",
    stroke: "#FFD194",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0859 14.2974H31.8159L33.0578 16.564",
    stroke: "#FFD194",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1025 53.3651H11.0313C9.6505 53.3651 8.53125 52.2459 8.53125 50.8651V24.2231C8.53125 22.8424 9.6505 21.7231 11.0313 21.7231H44.1025C45.4832 21.7231 46.6025 22.8424 46.6025 24.2231V50.8651C46.6025 52.2459 45.4832 53.3651 44.1025 53.3651Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8506 21.7231H11.0313C9.6505 21.7231 8.53125 22.8424 8.53125 24.2231V32.6765",
    stroke: "#F79009",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53125 48.888V50.8653C8.53125 52.246 9.6505 53.3653 11.0313 53.3653H44.1025C45.4833 53.3653 46.6025 52.246 46.6025 50.8653V24.2231C46.6025 22.8424 45.4833 21.7231 44.1025 21.7231H42.562",
    stroke: "#F79009",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0391 24.8481H13.7891",
    stroke: "#FFD194",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6836 24.8481H41.2805",
    stroke: "#FFD194",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "11.57 23.15"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7266 24.8481H43.4766V25.5981",
    stroke: "#FFD194",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4766 27.9263V30.2543",
    stroke: "#FFD194",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "9.31 18.62"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4766 31.418V32.168",
    stroke: "#FFD194",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4766 42.9194V43.6694",
    stroke: "#FFD194",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4766 45.998V48.3265",
    stroke: "#FFD194",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "9.31 18.63"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4766 49.4907V50.2407H42.7266",
    stroke: "#FFD194",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8313 50.2407H15.2344",
    stroke: "#FFD194",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "11.57 23.15"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7891 50.2407H13.0391",
    stroke: "#FFD194",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4391 42.9201H38.1875C36.1164 42.9201 34.4375 41.2412 34.4375 39.1701V35.9185C34.4375 33.8473 36.1164 32.1685 38.1875 32.1685H46.4391C47.1295 32.1685 47.6891 32.7281 47.6891 33.4185V41.6701C47.6891 42.3605 47.1295 42.9201 46.4391 42.9201Z",
    fill: "#FFD194"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4391 42.9201H38.1875C36.1164 42.9201 34.4375 41.2412 34.4375 39.1701V35.9185C34.4375 33.8473 36.1164 32.1685 38.1875 32.1685H46.4391C47.1295 32.1685 47.6891 32.7281 47.6891 33.4185V41.6701C47.6891 42.3605 47.1295 42.9201 46.4391 42.9201Z",
    stroke: "#F79009",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7539 39.1064C39.6169 39.1064 40.3164 38.4069 40.3164 37.5439C40.3164 36.681 39.6169 35.9814 38.7539 35.9814C37.891 35.9814 37.1914 36.681 37.1914 37.5439C37.1914 38.4069 37.891 39.1064 38.7539 39.1064Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53125 45.2778C12.6734 45.2778 16.0313 41.92 16.0313 37.7778C16.0313 33.6357 12.6734 30.2778 8.53125 30.2778C4.38911 30.2778 1.03125 33.6357 1.03125 37.7778C1.03125 41.92 4.38911 45.2778 8.53125 45.2778Z",
    fill: "#FFD194"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53125 43.4028C11.6379 43.4028 14.1563 40.8844 14.1563 37.7778C14.1563 34.6712 11.6379 32.1528 8.53125 32.1528C5.42465 32.1528 2.90625 34.6712 2.90625 37.7778C2.90625 40.8844 5.42465 43.4028 8.53125 43.4028Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53125 45.2778C12.6734 45.2778 16.0313 41.92 16.0313 37.7778C16.0313 33.6357 12.6734 30.2778 8.53125 30.2778C4.38911 30.2778 1.03125 33.6357 1.03125 37.7778C1.03125 41.92 4.38911 45.2778 8.53125 45.2778Z",
    stroke: "#F79009",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87372 39.912H10.4702L9.94259 37.778H7.11747L6.58984 35.644H10.1863",
    stroke: "#FFD194",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53125 39.9121V40.9031",
    stroke: "#FFD194",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53125 34.6528V35.6438",
    stroke: "#FFD194",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptoBasis);
export default __webpack_public_path__ + "static/media/cryptoBasis.65fc22e43630bf66401e20a2466033b1.svg";
export { ForwardRef as ReactComponent };